import { render, staticRenderFns } from "./RenjiDetail.vue?vue&type=template&id=c421a69e&scoped=true"
var script = {}
import style0 from "./RenjiDetail.vue?vue&type=style&index=0&id=c421a69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c421a69e",
  null
  
)

export default component.exports